"use client";

import { useFeatureFlag } from "@lib/feature-flags/FeatureFlagsContext";
import { hasTargetGroupFilter } from "./hasTargetGroupFilter";
import type { IPartFilter } from "@contentful-api/types/contentful";

export const useShowTargetGroupFilter = (listOfFilters: IPartFilter[]): boolean => {
    const isTargetGroupFilterHidden = useFeatureFlag("isTargetGroupFilterHidden");
    return hasTargetGroupFilter(listOfFilters) && !isTargetGroupFilterHidden;
};
